import { Alert } from "@mui/material"
import TextLabel from "../TextLabel";

type AlertBoxProps = {
    type: "success" | "error" | 'info' | 'warning';
    message: string;
    onCloseCb?: () => void;
}

const AlertBox = ({type, message, onCloseCb}: AlertBoxProps) => {

    return (
        <Alert severity={type} sx={{ width: '100%' }} onClose={onCloseCb}>
            <TextLabel type="regularText" variant="h5">{message}</TextLabel>
        </Alert>
    )
}

export default AlertBox;